// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-67c3e9cf]{display:block;margin-bottom:8px}.d1[data-v-67c3e9cf]{padding:32px}.mlr[data-v-67c3e9cf]{margin-right:56px;margin-left:12px}.add[data-v-67c3e9cf]{padding:10px 16px;margin-top:32px;gap:8px;width:84px;height:40px;background:#ff9428;border-radius:4px;font-family:Microsoft YaHei UI;font-style:normal;font-weight:400;font-size:14px;line-height:19px;color:#fff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
